(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-process-scrolly"] && !Shopify.designMode) return;
  try {
    
  // Prosess sticky-scroll: IntersectionObserver bytter aktivt steg/bilde/dot.
  // Indeks utledes fra NodeList-rekkefølge (ingen data-attributter nødvendig).
  // Skopet per seksjon, idempotent, og re-init ved Theme Editor section-load.
  (function () {
    function initScrolly(root) {
      if (!root || root.dataset.scrollyInit === '1') return;
      if (!('IntersectionObserver' in window)) return;

      var steps = Array.prototype.slice.call(root.querySelectorAll('.skm-scrolly__step'));
      var imgs = Array.prototype.slice.call(root.querySelectorAll('.skm-scrolly__img'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.skm-scrolly__dot'));
      if (!steps.length) return;

      root.dataset.scrollyInit = '1';

      function activate(i) {
        steps.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        imgs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      }

      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate(steps.indexOf(entry.target));
          }
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });

      steps.forEach(function (step) { obs.observe(step); });
    }

    function initAll() {
      document.querySelectorAll('.skm-scrolly').forEach(initScrolly);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Theme Editor: re-init når seksjonen lastes på nytt.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.skm-scrolly') : null;
      if (root) initScrolly(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-product-details"] && !Shopify.designMode) return;
  try {
    
  // Mobil bunn-bar: vis etter at brukeren har scrollet forbi hovedkjøpsboksen.
  (function () {
    var bars = document.querySelectorAll('[data-skm-mobilebar]');
    if (!bars.length) return;
    function update() {
      var show = window.scrollY > 700;
      bars.forEach(function (b) { b.classList.toggle('is-visible', show); });
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-produsent-hub"] && !Shopify.designMode) return;
  try {
    
/* ════ IIFE #1 — filter / disclosure / TOC-scroll / pin-highlight-bølge ════
   Idempotent per .skm-phub via dataset.phubInit.
   document-globale handlere bindes på modulnivå (én gang).
   syncPins-flippen er FJERNET: pins er dekorative på alle bredder. */
(function () {
  var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)');
  var mq = window.matchMedia('(min-width: 880px)');

  /* ── ENESTE STED å endre maks samtidige filter-tråder (data-viz-evidens: 4) ── */
  var MAX_THREADS = 4;
  function readMaxThreads() { return MAX_THREADS; }

  function initRoot(root) {
    if (root.dataset.phubInit === '1') return;   /* idempotens-guard */
    root.dataset.phubInit = '1';

    var chapters = Array.prototype.slice.call(root.querySelectorAll('.chapter'));
    var pins = Array.prototype.slice.call(root.querySelectorAll('.pin'));
    var VIS = 4;
    var filter = 'alle';

    function hasDyr(el, d) {
      var attr = el.getAttribute('data-dyr') || '';
      return (' ' + attr + ' ').indexOf(' ' + d + ' ') !== -1;
    }
    function isOn(el) { return filter === 'alle' || hasDyr(el, filter); }

    /* ── filter-tråd-bølge: ≤ MAX_THREADS hairline-paths, nord→sør sortert ── */
    function updateFilterThreads() {
      var mapCols = root.querySelector('.map__cols');
      if (!mapCols || !mq.matches) return;

      /* fjern gamle tråder */
      var old = mapCols.querySelectorAll('.thread');
      old.forEach(function (t) { t.remove(); });

      if (filter === 'alle') return;

      var card = root.querySelector('#pin-card');

      /* treff-pins synlige + sortert etter top% (nord→sør) */
      var treff = pins.filter(function (p) {
        return hasDyr(p, filter) && p.style.display !== 'none';
      });
      treff.sort(function (a, b) {
        var ay = parseFloat((a.getAttribute('style') || '').match(/top:([\d.]+)%/) && (a.getAttribute('style').match(/top:([\d.]+)%/)[1])) || 0;
        var by = parseFloat((b.getAttribute('style') || '').match(/top:([\d.]+)%/) && (b.getAttribute('style').match(/top:([\d.]+)%/)[1])) || 0;
        return ay - by;
      });

      var mRect = mapCols.getBoundingClientRect();
      var maxT = readMaxThreads();
      var subset = treff.slice(0, maxT);

      subset.forEach(function (pin, i) {
        var pRect = pin.getBoundingClientRect();
        var px = (pRect.left + pRect.width / 2 - mRect.left).toFixed(1);
        var py = (pRect.top + pRect.height / 2 - mRect.top).toFixed(1);
        /* trekk tråd mot høyre kants midtpunkt (symbolsk, ingen card-posisjon ved multi) */
        var ex = (mRect.width - 4).toFixed(1);
        var ey = py;
        /* kurve: 12% perpendikulær offset */
        var dx = parseFloat(ex) - parseFloat(px);
        var dy = 0;
        var len = Math.abs(dx) || 1;
        var off = len * 0.12;
        var ctrlX = ((parseFloat(px) + parseFloat(ex)) / 2).toFixed(1);
        var ctrlY = (parseFloat(py) + off * (i % 2 === 0 ? -1 : 1)).toFixed(1);
        var d = 'M' + px + ' ' + py + ' Q' + ctrlX + ' ' + ctrlY + ' ' + ex + ' ' + ey;

        var svgNS = 'http://www.w3.org/2000/svg';
        var path = document.createElementNS(svgNS, 'path');
        path.setAttribute('class', 'thread');
        path.setAttribute('d', d);
        path.setAttribute('aria-hidden', 'true');
        path.style.setProperty('--i', i);
        if (!motionOK.matches) {
          /* reduced-motion: sluttilstand direkte, ingen stagger */
          path.style.transition = 'none';
          path.style.opacity = '.28';
        }
        /* legg til ETTER map__stage (tredje child av map__cols, men SVG-tråd er sibling) */
        var lineSvg = mapCols.querySelector('.pin__card-line');
        mapCols.insertBefore(path, lineSvg || null);

        /* trigger transition (rAF for å la nettleseren se opacity:0 først) */
        requestAnimationFrame(function () {
          path.classList.add('is-on');
          /* fjern will-change etter transition */
          path.addEventListener('transitionend', function () {
            path.style.willChange = 'auto';
          }, { once: true });
        });
      });
    }

    /* ── pin-highlight ved filter ── */
    function updatePinHighlight() {
      pins.forEach(function (p) {
        p.classList.remove('pin--highlight', 'pin--dim');
        if (filter === 'alle') return;
        if (hasDyr(p, filter) && p.style.display !== 'none') {
          p.classList.add('pin--highlight');
        } else if (p.style.display !== 'none') {
          p.classList.add('pin--dim');
        }
      });
    }

    function refresh() {
      var filterTotal = 0;

      chapters.forEach(function (ch) {
        var rows = Array.prototype.slice.call(ch.querySelectorAll('.row'));
        var tiles = Array.prototype.slice.call(ch.querySelectorAll('.tile-alt'));
        var btn = ch.querySelector('.reveal');
        var exit = ch.querySelector('.chapter__exit');
        var expanded = btn && btn.getAttribute('aria-expanded') === 'true';

        var on = rows.filter(isOn);
        var n = on.length;
        filterTotal += n;
        ch.hidden = n === 0;

        var anchorRow = null;
        tiles.forEach(function (t) { t.hidden = true; });
        if (n > 0 && tiles.length > 0) {
          var cand = on[0];
          tiles.some(function (t) {
            if (t.getAttribute('data-member') === cand.id) { t.hidden = false; anchorRow = cand; return true; }
            return false;
          });
        }

        var listRows = on.filter(function (r) { return r !== anchorRow; });
        var cap = anchorRow ? VIS - 1 : VIS;
        var moreCount = 0;
        rows.forEach(function (r) {
          delete r.dataset.more;
          if (!isOn(r) || r === anchorRow) { r.hidden = true; return; }
          if (listRows.indexOf(r) < cap) { r.hidden = false; }
          else { r.dataset.more = '1'; moreCount += 1; r.hidden = !expanded; }
        });

        if (btn) {
          btn.hidden = moreCount === 0;
          if (btn.hidden && expanded) { btn.setAttribute('aria-expanded', 'false'); expanded = false; }
          var lbl = btn.querySelector('[data-reveal-label]');
          if (lbl) {
            if (expanded) { lbl.textContent = 'Vis færre'; }
            else {
              lbl.textContent = 'Vis alle ';
              var bn = document.createElement('b');
              bn.className = 'tn';
              bn.textContent = n;
              lbl.appendChild(bn);
              lbl.appendChild(document.createTextNode(' i ' + btn.getAttribute('data-title')));
            }
          }
        }
        if (exit) exit.hidden = n <= 3;

        var cc = ch.querySelector('[data-chapter-count]');
        if (cc) cc.textContent = n + ' ' + (n === 1 ? 'produsent' : 'produsenter');

        var label = root.querySelector('[data-reg-count="' + ch.id + '"]');
        if (label) label.textContent = n;

        var toc = root.querySelector('.toc__row[href="#' + ch.id + '"]');
        if (toc) {
          toc.classList.toggle('is-off', n === 0);
          if (n === 0) { toc.setAttribute('aria-disabled', 'true'); toc.setAttribute('tabindex', '-1'); }
          else { toc.removeAttribute('aria-disabled'); toc.removeAttribute('tabindex'); }
          var tc = toc.querySelector('[data-toc-count]');
          var tw = toc.querySelector('[data-toc-word]');
          if (tc) tc.textContent = n;
          if (tw) tw.textContent = n === 1 ? 'produsent' : 'produsenter';
        }
      });

      pins.forEach(function (p) {
        p.style.display = isOn(p) ? '' : 'none';
      });

      /* ── aria-live status (én streng, én node) ── */
      var liveEl = root.querySelector('#geo-filter-status');
      if (liveEl) {
        if (filter === 'alle') {
          liveEl.textContent = '';
        } else {
          liveEl.textContent = filterTotal + (filterTotal === 1 ? ' gård' : ' gårder') + ' leverer ' + filter;
        }
      }

      /* ── visuell bølge + highlight (desktop-progressiv forbedring) ── */
      updatePinHighlight();
      updateFilterThreads();
    }

    Array.prototype.slice.call(root.querySelectorAll('.filter')).forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.getAttribute('data-filter');
        Array.prototype.slice.call(root.querySelectorAll('.filter')).forEach(function (x) {
          x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
        });
        refresh();
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-scroll]')).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (a.classList.contains('is-off')) return;
        var target = root.querySelector(a.getAttribute('href'));
        if (!target) return;
        target.scrollIntoView({ behavior: motionOK.matches ? 'smooth' : 'auto' });
        var h = target.querySelector('h2');
        if (h) h.focus({ preventScroll: true });
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('.reveal')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        refresh();
      });
    });

    /* pins: dekorative på alle bredder — tabindex="-1" aria-hidden="true" alltid.
       syncPins-flippen er FJERNET; pointer-events settes av CSS @880px. */
    pins.forEach(function (p) {
      p.tabIndex = -1;
      p.setAttribute('aria-hidden', 'true');
    });
  }

  function initAll() { document.querySelectorAll('.skm-phub').forEach(initRoot); }
  document.addEventListener('DOMContentLoaded', initAll);
  initAll();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('.skm-phub');
    if (el) { delete el.dataset.phubInit; initRoot(el); }
  });
})();

/* ════ IIFE #2 — leader-line pin-kort, bezier-tråd, dash-tegning ════
   Idempotent per .skm-phub via dataset.phubCardInit.
   ESC / klikk-utenfor / resize: modulnivå (bind én gang) opererer på activeRoots-map.
   Pins er DEKORATIVE: ingen focus/blur-triggere. Tråd+kort = mouseenter + click. */
(function () {
  var MQ = window.matchMedia('(min-width: 880px)');
  var motionOK = window.matchMedia('(prefers-reduced-motion: no-preference)');

  /* Modul-skoped referanse til aktivt kort per root (for ESC/click-outside) */
  var activeRoots = []; /* [{root, getActivePin, closeCard}] */

  /* ── dyr-ikonbibliotek (inline SVG, nøytral fallback) ── */
  var DYR_ICON = {
    storfe:   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9c0 2.8 2.2 5 5 5h6c2.8 0 5-2.2 5-5"/><path d="M7 9V7a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v2"/><ellipse cx="9" cy="18" rx="1.5" ry="2.5"/><ellipse cx="15" cy="18" rx="1.5" ry="2.5"/><path d="M4 9H2m18 0h2"/></svg>',
    svin:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="13" rx="7" ry="5.5"/><circle cx="9.5" cy="12" r=".8" fill="currentColor"/><circle cx="14.5" cy="12" r=".8" fill="currentColor"/><path d="M8 7.5C8 5.6 9.8 4 12 4s4 1.6 4 3.5"/><path d="M6 18v2m12-2v2"/></svg>',
    kylling:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3c-2 0-3.5 1.3-3.5 3 0 1 .5 1.9 1.3 2.5L8 11H6a2 2 0 0 0 0 4h1l1 4h6l1-4h1a2 2 0 0 0 0-4h-2l-1.8-2.5c.8-.6 1.3-1.5 1.3-2.5C12.5 4.3 14 3 12 3z"/><path d="M15 6l2-1.5"/></svg>',
    sau:      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><ellipse cx="12" cy="12" rx="5" ry="4"/><circle cx="8" cy="10" r="2.5"/><circle cx="16" cy="10" r="2.5"/><circle cx="12" cy="8" r="2"/><path d="M9 16v3m6-3v3"/></svg>',
    reinsdyr: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5c0 0-1-2-3-2s-1 2 0 3"/><path d="M12 5c0 0 1-2 3-2s1 2 0 3"/><path d="M12 8c-3 0-5 2-5 5 0 2 1 3.5 2.5 4.5L9 21h6l-.5-3.5C16 16.5 17 15 17 13c0-3-2-5-5-5z"/><path d="M9 21l-1 .5M15 21l1 .5"/></svg>',
    vilt:     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4c0 0-2-2-4-1s-1 3 0 4"/><path d="M12 4c0 0 2-2 4-1s1 3 0 4"/><path d="M8 7c-2.5 1-3 3-3 5 0 2.5 1.5 4 3 5l-.5 3h9l-.5-3c1.5-1 3-2.5 3-5 0-2-0.5-4-3-5"/></svg>',
    _fallback:'<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2m0 16v2M2 12h2m16 0h2"/></svg>'
  };

  function getIcon(dyrStr) {
    var d = (dyrStr || '').toLowerCase();
    for (var k in DYR_ICON) {
      if (k !== '_fallback' && d.indexOf(k) !== -1) return DYR_ICON[k];
    }
    return DYR_ICON._fallback;
  }

  /* ── modulnivå ESC + klikk-utenfor + resize (bundet én gang) ── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    activeRoots.forEach(function (entry) {
      var pin = entry.getActivePin();
      if (!pin) return;
      entry.closeCard();
      if (pin.focus) pin.focus();
    });
  });

  document.addEventListener('click', function (e) {
    activeRoots.forEach(function (entry) {
      if (!entry.getActivePin()) return;
      var card = entry.root.querySelector('#pin-card');
      if (!card) return;
      if (card.contains(e.target) || e.target.classList.contains('pin') || e.target.closest('.pin')) return;
      entry.closeCard();
    });
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      activeRoots.forEach(function (entry) {
        var pin = entry.getActivePin();
        if (!pin || !MQ.matches) return;
        entry.repositionAndDraw(pin);
      });
    }, 80);
  });

  function initCard(root) {
    if (root.dataset.phubCardInit === '1') return;   /* idempotens-guard */
    root.dataset.phubCardInit = '1';

    var card     = root.querySelector('#pin-card');
    var lineEl   = root.querySelector('.pin__card-line-el');
    var iconEl   = root.querySelector('.pin__card-icon');
    var navnEl   = root.querySelector('.pin__card-navn');
    var stedEl   = root.querySelector('.pin__card-sted');
    var sigEl    = root.querySelector('.pin__card-sig');
    var linkEl   = root.querySelector('.pin__card-link');
    var mapCols  = root.querySelector('.map__cols');
    var mapStage = root.querySelector('.map__stage');

    if (!card || !mapStage) return;

    var activePin = null;
    var inView = false;   /* IntersectionObserver-flagg */

    /* ── IntersectionObserver: geometri beregnes først i viewport ── */
    if (typeof IntersectionObserver !== 'undefined') {
      var mapWrap = root.querySelector('.map__wrap');
      if (mapWrap) {
        new IntersectionObserver(function (entries) {
          inView = entries[0].isIntersecting;
          if (inView && activePin && MQ.matches) {
            repositionAndDraw(activePin);
          }
        }, { threshold: 0.1 }).observe(mapWrap);
      }
    } else {
      inView = true;
    }

    function closeCard() {
      if (!activePin) return;
      activePin.classList.remove('is-active');
      activePin = null;
      card.hidden = true;
      if (lineEl) {
        lineEl.setAttribute('d', '');
        lineEl.classList.remove('is-drawing');
        lineEl.style.strokeDashoffset = '';
        lineEl.style.transition = '';
      }
    }

    /* ── bezier-kurve (12% perpendikulær offset) ── */
    function drawLine(pin) {
      if (!MQ.matches || !lineEl || !mapCols) return;
      var mRect = mapCols.getBoundingClientRect();
      var pRect = pin.getBoundingClientRect();
      var cRect = card.getBoundingClientRect();
      var px = pRect.left + pRect.width  / 2 - mRect.left;
      var py = pRect.top  + pRect.height / 2 - mRect.top;
      var cx = cRect.left - mRect.left;
      var cy = cRect.top  + cRect.height / 2 - mRect.top;
      var mx = (px + cx) / 2, my = (py + cy) / 2;
      var dx = cx - px, dy = cy - py;
      var len = Math.hypot(dx, dy) || 1;
      var off = len * 0.12;
      var ctrlX = mx + (-dy / len) * off;
      var ctrlY = my + ( dx / len) * off;
      lineEl.setAttribute('d',
        'M' + px.toFixed(1) + ' ' + py.toFixed(1) +
        ' Q' + ctrlX.toFixed(1) + ' ' + ctrlY.toFixed(1) +
        ' ' + cx.toFixed(1) + ' ' + cy.toFixed(1));
      animateThread();
    }

    /* ── dash-tegning: .is-drawing (heltrukken) → transitionend → 3 4 (prikket) ── */
    function animateThread() {
      if (!lineEl) return;
      if (motionOK.matches && MQ.matches) {
        lineEl.classList.add('is-drawing');           /* dasharray:1 heltrukken */
        lineEl.style.strokeDashoffset = '1';
        lineEl.getBoundingClientRect();               /* tving reflow */
        lineEl.style.transition = 'stroke-dashoffset 320ms var(--skm-ease-emphasis, ease-out)';
        lineEl.style.strokeDashoffset = '0';
        lineEl.addEventListener('transitionend', function te(ev) {
          if (ev.propertyName !== 'stroke-dashoffset') return;
          lineEl.removeEventListener('transitionend', te);
          lineEl.style.transition = 'none';
          lineEl.style.strokeDashoffset = '';
          lineEl.classList.remove('is-drawing');      /* tilbake til dasharray:3 4 prikket */
        });
      } else {
        /* reduced-motion: sett prikket sluttilstand DIREKTE (l.1061 dreper inline transition) */
        lineEl.classList.remove('is-drawing');
        lineEl.style.transition = 'none';
        lineEl.style.strokeDashoffset = '';
      }
    }

    function positionCardDesktop(pin) {
      if (!MQ.matches || !mapCols) return;
      var style = pin.getAttribute('style') || '';
      var topMatch = style.match(/top:([\d.]+)%/);
      var pinTopPct = topMatch ? parseFloat(topMatch[1]) : 50;
      var colsH = mapCols.offsetHeight;
      var desiredTop = (pinTopPct / 100) * mapStage.offsetHeight - 60;
      var maxTop = colsH - card.offsetHeight - 8;
      var top = Math.max(8, Math.min(desiredTop, maxTop));
      card.style.top = top + 'px';
    }

    function repositionAndDraw(pin) {
      positionCardDesktop(pin);
      requestAnimationFrame(function () { drawLine(pin); });
    }

    function openCard(pin) {
      if (activePin === pin) { closeCard(); return; }
      if (activePin) { activePin.classList.remove('is-active'); }

      var navn   = pin.dataset.cardNavn   || '';
      var sted   = pin.dataset.cardSted   || '';
      var sig    = pin.dataset.cardSig    || '';
      var dyr    = pin.dataset.cardDyr    || '';
      var url    = pin.dataset.cardUrl    || '';
      var status = pin.dataset.cardStatus || '';

      iconEl.innerHTML = getIcon(dyr);
      navnEl.textContent = navn;
      stedEl.textContent = sted;
      sigEl.textContent  = sig;

      if (status === 'aktiv' && url) {
        linkEl.href = url;
        linkEl.textContent = 'Les om ' + navn + ' →';
        linkEl.hidden = false;
      } else {
        linkEl.hidden = true;
      }

      activePin = pin;
      pin.classList.add('is-active');
      card.hidden = false;

      if (MQ.matches && inView) {
        repositionAndDraw(pin);
      }
    }

    /* ── pin-bindinger: KUN mouseenter + mouseleave + click (focus/blur fjernet) ── */
    root.querySelectorAll('.pin').forEach(function (pin) {
      pin.addEventListener('mouseenter', function () {
        if (!MQ.matches) return;
        openCard(pin);
      });
      pin.addEventListener('mouseleave', function () {
        if (!MQ.matches) return;
        setTimeout(function () {
          if (card.matches(':hover')) return;
          if (activePin === pin) closeCard();
        }, 80);
      });
      pin.addEventListener('click', function () {
        openCard(pin);
      });
    });

    /* hold kortet åpent når musen er over det */
    card.addEventListener('mouseleave', function () {
      if (!MQ.matches) return;
      setTimeout(function () {
        if (activePin && !activePin.matches(':hover')) closeCard();
      }, 80);
    });

    /* filter capture: lukk kortet hvis aktiv pin skjules */
    root.querySelectorAll('.filter').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (activePin && activePin.style.display === 'none') closeCard();
      }, true);
    });

    /* Registrer i modul-scope for ESC/click-outside/resize */
    activeRoots.push({
      root: root,
      getActivePin: function () { return activePin; },
      closeCard: closeCard,
      repositionAndDraw: repositionAndDraw
    });
  }

  function initAllCards() { document.querySelectorAll('.skm-phub').forEach(initCard); }
  document.addEventListener('DOMContentLoaded', initAllCards);
  initAllCards();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('.skm-phub');
    if (el) {
      /* fjern gammel entry fra activeRoots hvis finnes */
      activeRoots = activeRoots.filter(function (entry) { return entry.root !== el; });
      delete el.dataset.phubCardInit;
      initCard(el);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-produsent-profil"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.skm-prodp').forEach(function(sec){
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var els=sec.querySelectorAll('[data-reveal]');
    if(reduce||!('IntersectionObserver'in window)){els.forEach(function(el){el.classList.add('is-in');});return;}
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        // Over viewporten (anker, tilbakeknapp, raskt sveip) vises med en gang, ellers blir det usynlig.
        if(en.isIntersecting||en.boundingClientRect.top<0){en.target.classList.add('is-in');io.unobserve(en.target);}
      });
    },{rootMargin:'0px 0px -10% 0px',threshold:.12});
    els.forEach(function(el){io.observe(el);});
    sec.classList.add('is-reveal-armed');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-forhandler-skjema"]) return;
  try {
    
// Inline validering og spam-vern for forhandlerskjemaet. Bevisst duplikat av
// IIFE-en i skm-v2-kontakt-skjema.liquid, se kommentaren i toppen av seksjonen.
// Forskjellen som betyr noe: denne selekterer paa attributtet
// [data-skm-skjema], ikke paa et klassenavn. Delegert til document, saa lytterne
// ikke doer naar theme dev morfer seksjons-DOM-en. Tilstand i WeakMap, aldri
// dataset-flagg.
(() => {
  const TERSKEL = 3000;
  const lastet = new WeakMap();
  const klargjort = new WeakSet();

  const SKJEMA = '[data-skm-skjema]';

  // Slaar av nettleserens egen validering FOERST naar JS finnes, saa no-JS
  // beholder den native som fallback.
  const klargjor = (form) => {
    if (klargjort.has(form)) return;
    klargjort.add(form);
    form.noValidate = true;
    if (!lastet.has(form)) lastet.set(form, Date.now());
  };

  const feilnode = (felt) => {
    const id = `${felt.id}-feil`;
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement('p');
      node.id = id;
      node.className = 'skm-v2-fskjema__feilmelding';
      node.setAttribute('role', 'alert');
      (felt.closest('.skm-v2-fskjema__velg') || felt).insertAdjacentElement('afterend', node);
    }
    return node;
  };

  const merkFeil = (felt) => {
    const node = feilnode(felt);
    node.textContent = felt.dataset.feilmelding || 'Fyll ut dette feltet.';
    node.hidden = false;
    felt.setAttribute('aria-invalid', 'true');
    const beskrevet = (felt.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (!beskrevet.includes(node.id)) {
      felt.setAttribute('aria-describedby', [...beskrevet, node.id].join(' '));
    }
  };

  const fjernFeil = (felt) => {
    const node = document.getElementById(`${felt.id}-feil`);
    if (node) node.hidden = true;
    felt.removeAttribute('aria-invalid');
  };

  document.addEventListener('focusin', (e) => {
    const form = e.target.closest?.(SKJEMA);
    if (form) klargjor(form);
  }, true);

  // Rydder feilen saa fort feltet blir gyldig, ikke foerst ved neste submit.
  document.addEventListener('input', (e) => {
    const felt = e.target;
    if (!felt.closest?.(SKJEMA)) return;
    if (felt.checkValidity?.()) fjernFeil(felt);
  }, true);

  document.addEventListener('change', (e) => {
    const felt = e.target;
    if (!felt.closest?.(SKJEMA)) return;
    if (felt.checkValidity?.()) fjernFeil(felt);
  }, true);

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.matches?.(SKJEMA)) return;
    klargjor(form);

    const krukke = form.querySelector('input[name="skm_nettsted"]');
    if (krukke && krukke.value.trim() !== '') {
      e.preventDefault();
      return;
    }

    const start = lastet.get(form);
    if (start && Date.now() - start < TERSKEL) {
      e.preventDefault();
      return;
    }

    const felter = form.querySelectorAll('[required]');
    let foerste = null;
    felter.forEach((felt) => {
      if (felt.checkValidity()) {
        fjernFeil(felt);
      } else {
        merkFeil(felt);
        if (!foerste) foerste = felt;
      }
    });

    if (foerste) {
      e.preventDefault();
      foerste.focus();
      foerste.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-kontakt-skjema"] && !Shopify.designMode) return;
  try {
    
// Inline validering og spam-vern. Delegert til document, saa lytterne ikke doer
// naar theme dev morfer seksjons-DOM-en (samme aarsak som registeret paa
// Produsentene). Tilstand i WeakMap, aldri dataset-flagg.
(() => {
  const TERSKEL = 3000;
  const lastet = new WeakMap();
  const klargjort = new WeakSet();

  const SKJEMA = '.skm-v2-kskjema__felt';

  // Slaar av nettleserens egen validering FOERST naar JS finnes, saa no-JS
  // beholder den native som fallback.
  const klargjor = (form) => {
    if (klargjort.has(form)) return;
    klargjort.add(form);
    form.noValidate = true;
    if (!lastet.has(form)) lastet.set(form, Date.now());
  };

  const feilnode = (felt) => {
    const id = `${felt.id}-feil`;
    let node = document.getElementById(id);
    if (!node) {
      node = document.createElement('p');
      node.id = id;
      node.className = 'skm-v2-kskjema__feilmelding';
      node.setAttribute('role', 'alert');
      (felt.closest('.skm-v2-kskjema__velg') || felt).insertAdjacentElement('afterend', node);
    }
    return node;
  };

  const merkFeil = (felt) => {
    const node = feilnode(felt);
    node.textContent = felt.dataset.feilmelding || 'Fyll ut dette feltet.';
    node.hidden = false;
    felt.setAttribute('aria-invalid', 'true');
    const beskrevet = (felt.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (!beskrevet.includes(node.id)) {
      felt.setAttribute('aria-describedby', [...beskrevet, node.id].join(' '));
    }
  };

  const fjernFeil = (felt) => {
    const node = document.getElementById(`${felt.id}-feil`);
    if (node) node.hidden = true;
    felt.removeAttribute('aria-invalid');
  };

  document.addEventListener('focusin', (e) => {
    const form = e.target.closest?.(SKJEMA);
    if (form) klargjor(form);
  }, true);

  // Rydder feilen saa fort feltet blir gyldig, ikke foerst ved neste submit.
  document.addEventListener('input', (e) => {
    const felt = e.target;
    if (!felt.closest?.(SKJEMA)) return;
    if (felt.checkValidity?.()) fjernFeil(felt);
  }, true);

  document.addEventListener('change', (e) => {
    const felt = e.target;
    if (!felt.closest?.(SKJEMA)) return;
    if (felt.checkValidity?.()) fjernFeil(felt);
  }, true);

  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.classList?.contains('skm-v2-kskjema__felt')) return;
    klargjor(form);

    const krukke = form.querySelector('input[name="skm_nettsted"]');
    if (krukke && krukke.value.trim() !== '') {
      e.preventDefault();
      return;
    }

    const start = lastet.get(form);
    if (start && Date.now() - start < TERSKEL) {
      e.preventDefault();
      return;
    }

    const felter = form.querySelectorAll('[required]');
    let foerste = null;
    felter.forEach((felt) => {
      if (felt.checkValidity()) {
        fjernFeil(felt);
      } else {
        merkFeil(felt);
        if (!foerste) foerste = felt;
      }
    });

    if (foerste) {
      e.preventDefault();
      foerste.focus();
      foerste.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  // Galleri (thumb-bytte, hover-krysstoning, sekvensmodus) + mobil bunn-bar.
  // Skopet per seksjon, idempotent, re-init ved Theme Editor section-load.
  (function () {
    var SEQ_STEP_MS = 1200;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function initGallery(root) {
      if (!root || root.dataset.skmV2GalleryInit === '1') return;
      var imgs = Array.prototype.slice.call(root.querySelectorAll('.skm-v2-hero__stage-img'));
      if (!imgs.length) return;
      root.dataset.skmV2GalleryInit = '1';

      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-skm-v2-thumb]'));
      var playBtn = root.querySelector('[data-skm-v2-play]');
      var stage = root.querySelector('.skm-v2-hero__stage');
      var selected = 0;
      var seqTimer = null;
      var seqIndex = 0;

      function show(i) {
        imgs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        thumbs.forEach(function (el, idx) {
          el.classList.toggle('is-active', idx === i);
          el.setAttribute('aria-pressed', idx === i ? 'true' : 'false');
        });
      }

      function stopSequence() {
        if (seqTimer) {
          clearInterval(seqTimer);
          seqTimer = null;
        }
        show(selected);
      }

      // Sekvens sykler i bruk-bildene (indeks 1..n), aldri katalog-shotet.
      function startSequence() {
        if (imgs.length < 3 || seqTimer || prefersReducedMotion()) return;
        seqIndex = 1;
        show(seqIndex);
        seqTimer = setInterval(function () {
          seqIndex = seqIndex + 1;
          if (seqIndex >= imgs.length) seqIndex = 1;
          show(seqIndex);
        }, SEQ_STEP_MS);
      }

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          stopSequence();
          selected = parseInt(btn.dataset.skmV2Thumb, 10) || 0;
          show(selected);
        });
      });

      // Hover paa ekte peke-enheter. 2 bilder = bytt, 3+ = sekvens.
      if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches && stage) {
        stage.addEventListener('mouseenter', function () {
          if (imgs.length >= 3) {
            startSequence();
          } else if (imgs.length === 2) {
            show(1);
          }
        });
        stage.addEventListener('mouseleave', function () {
          stopSequence();
        });
      }

      // Touch-inngang til sekvensen. Knappen vises kun der hover ikke finnes.
      if (playBtn) {
        if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) && !prefersReducedMotion()) {
          playBtn.hidden = false;
        }
        playBtn.addEventListener('click', function () {
          if (seqTimer) {
            stopSequence();
          } else {
            startSequence();
          }
        });
      }
    }

    function initMobilebar() {
      var bars = document.querySelectorAll('[data-skm-v2-mobilebar]');
      if (!bars.length) return;
      var buyzone = document.querySelector('[data-skm-v2-buyzone]');
      function update() {
        var threshold = 700;
        if (buyzone) {
          var rect = buyzone.getBoundingClientRect();
          threshold = rect.top + window.scrollY + 200;
        }
        var show = window.scrollY > threshold;
        bars.forEach(function (b) { b.classList.toggle('is-visible', show); });
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    function initAll() {
      document.querySelectorAll('[data-skm-v2-gallery]').forEach(initGallery);
      initMobilebar();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-process"] && !Shopify.designMode) return;
  try {
    
  // Sticky-scroll: IntersectionObserver bytter aktivt steg/bilde/dot.
  // Skopet per seksjon, idempotent, re-init ved Theme Editor section-load.
  (function () {
    function initScrolly(root) {
      if (!root || root.dataset.skmV2ScrollyInit === '1') return;
      if (!('IntersectionObserver' in window)) return;

      var steps = Array.prototype.slice.call(root.querySelectorAll('.skm-v2-process__step'));
      var imgs = Array.prototype.slice.call(root.querySelectorAll('.skm-v2-process__img'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.skm-v2-process__dot'));
      if (!steps.length) return;

      root.dataset.skmV2ScrollyInit = '1';

      function activate(i) {
        steps.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        imgs.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
        dots.forEach(function (el, idx) { el.classList.toggle('is-active', idx === i); });
      }

      // Senter-linje-trigger: root krympes til en 0-hoyde linje midt i
      // viewporten (-50%/-50%), saa steget hvis boks dekker senter blir
      // aktivt. Med 100svh-steg holder ett steg senter om gangen, likt dvele.
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            activate(steps.indexOf(entry.target));
          }
        });
      }, { rootMargin: '-50% 0px -50% 0px', threshold: 0 });

      steps.forEach(function (step) { obs.observe(step); });
    }

    function initAll() {
      document.querySelectorAll('.skm-v2-process').forEach(initScrolly);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector ? e.target.querySelector('.skm-v2-process') : null;
      if (root) initScrolly(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-produsent-register"] && !Shopify.designMode) return;
  try {
    
  // Lokatoren, punkt 6: helkart -> kinematisk zoom inn på prikken ->
  // gårdsikon med stedsnavn og avstand avsløres PÅ kartet mot slutten.
  // Radbytte glir ved korte hopp, tar helkart-runden ved lange. KUN KLIKK
  // driver valget (runde 3-vedtaket): ingenting i kartet endres av
  // scrolling alene, og hviletilstanden er helkart uten pin til første
  // klikk. prefers-reduced-motion får sluttbildet direkte uten sekvens.
  // Konstantene under er skruene for iterasjonen.
  //
  // KLIKKENE ER DELEGERT til document (2026-07-31): theme dev-hot-reload og
  // Theme Editor swapper seksjons-DOM-en mange ganger i en iterasjonsøkt, og
  // lyttere bundet på radene dør med de gamle nodene. En dokument-lytter kan
  // ikke dø, init skjer lazy ved første klikk, og en liveness-sjekk fanger
  // morfede røtter (samme rotnode, nye barn) og init-er på nytt. Tilstanden
  // bor i en WeakMap på rotnoden, aldri i dataset-flagg som kan overleve en
  // morf med døde lyttere.
  (function () {
    var NAER_ZOOM = 6.5;      // sluttforstørrelse på prikken
    var OVERSAMPLE = 5;       // stagen er lagt ut i 500 %, MÅ speile CSS-en
    var DUR_INN = 1200;       // kinematisk innzooming, speiler --t-cinematic
    var DUR_UT = 420;         // tilbake til helkart, speiler --t-slow
    var DUR_GLI = 650;        // gli mellom nærliggende prikker
    var DUR_FADE = 420;       // oppslagets opacity-transisjon, speiler --t-slow
    var GLIDE_GRENSE = 14;    // % av kartet; lengre hopp tar helkart-runden

    function redusertBevegelse() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function haversineKm(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var rad = Math.PI / 180;
      var dLat = (lat2 - lat1) * rad;
      var dLng = (lng2 - lng1) * rad;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(a));
    }

    function avstandTekst(km) {
      if (km < 5) return 'under 5 km fra Superkraftfabrikken';
      return 'omtrent ' + (Math.round(km / 5) * 5) + ' km fra Superkraftfabrikken';
    }

    // rot-node -> instans-API. WeakMap-en er sannheten om hvorvidt en rot er
    // initiert; en swappet rot er en ny nøkkel og får frisk init av seg selv.
    var API = new WeakMap();

    function initRegister(root) {
      if (!root) return null;
      var eksisterende = API.get(root);
      if (eksisterende) return eksisterende;
      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-skm-v2-regrow]'));
      var kart = root.querySelector('[data-skm-v2-kart]');
      var stage = root.querySelector('[data-skm-v2-stage]');
      var pin = root.querySelector('[data-skm-v2-pin]');
      var oppslag = root.querySelector('[data-skm-v2-lok-oppslag]');
      if (!rows.length || !kart || !stage || !pin || !oppslag) return null;

      var stedEl = root.querySelector('[data-skm-v2-lok-sted]');
      var avstandEl = root.querySelector('[data-skm-v2-lok-avstand]');
      var srStatus = root.querySelector('[data-skm-v2-lok-status]');
      var mLat = parseFloat(root.dataset.moelvLat);
      var mLng = parseFloat(root.dataset.moelvLng);

      var aktiv = null;
      var zoomet = false;
      var timere = [];

      function stopp() {
        timere.forEach(clearTimeout);
        timere = [];
      }
      function etter(ms, fn) {
        timere.push(setTimeout(fn, ms));
      }

      // Kamera: sentrer punktet (x%, y%) i panelet ved visuell skala S.
      // Stagen er oversamplet, så påført skala er S/OVERSAMPLE, mens
      // translatene regnes i panelpiksler og er uavhengige av faktoren.
      function kamera(S, xPct, yPct, dur) {
        var r = kart.getBoundingClientRect();
        var s = S / OVERSAMPLE;
        var tx = r.width / 2 - S * (xPct / 100) * r.width;
        var ty = r.height / 2 - S * (yPct / 100) * r.height;
        kart.style.setProperty('--lok-dur', dur + 'ms');
        kart.style.setProperty('--lok-zoom', s);
        stage.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + s + ')';
      }
      function helkart(dur) {
        var s = 1 / OVERSAMPLE;
        kart.style.setProperty('--lok-dur', dur + 'ms');
        kart.style.setProperty('--lok-zoom', s);
        stage.style.transform = 'scale(' + s + ')';
      }

      // Posisjon og innhold byttes hver for seg: posisjonen flyttes med en
      // gang så oppslaget glir med pinnen, innholdet (navn, avstand, ikon)
      // byttes først når det gamle oppslaget er ferdig utfadet. Ellers
      // hopper navnet til ny gård mens det gamle fortsatt er synlig.
      function flytt(row) {
        pin.style.left = row.dataset.x + '%';
        pin.style.top = row.dataset.y + '%';
        oppslag.style.left = row.dataset.x + '%';
        oppslag.style.top = row.dataset.y + '%';
      }
      function fyll(row) {
        if (stedEl) stedEl.textContent = row.dataset.sted || '';
        var tekst = '';
        var lat = parseFloat(row.dataset.lat);
        var lng = parseFloat(row.dataset.lng);
        if (isFinite(lat) && isFinite(lng) && isFinite(mLat) && isFinite(mLng)) {
          tekst = avstandTekst(haversineKm(mLat, mLng, lat, lng));
        }
        if (avstandEl) avstandEl.textContent = tekst;
        Array.prototype.slice.call(oppslag.querySelectorAll('[data-lok-ikon]')).forEach(function (el) {
          el.hidden = el.dataset.lokIkon !== (row.dataset.type || 'gård');
        });
        if (srStatus) srStatus.textContent = (row.dataset.sted || '') + (tekst ? ', ' + tekst : '');
      }
      function plasser(row) {
        flytt(row);
        fyll(row);
      }
      function vis() { oppslag.classList.add('er-synlig'); }
      function skjul() { oppslag.classList.remove('er-synlig'); }

      function velg(row) {
        if (!row || row === aktiv) return;
        var forrige = aktiv;
        aktiv = row;
        rows.forEach(function (r) {
          var a = r === row;
          r.classList.toggle('is-aktiv', a);
          r.setAttribute('aria-pressed', a ? 'true' : 'false');
        });
        stopp();
        pin.classList.add('er-synlig');
        var x = parseFloat(row.dataset.x);
        var y = parseFloat(row.dataset.y);

        if (redusertBevegelse()) {
          plasser(row);
          kamera(NAER_ZOOM, x, y, 0);
          vis();
          zoomet = true;
          return;
        }

        skjul();
        if (!zoomet) {
          // Sekvensen: hele landet i bildet, så rolig inn på prikken.
          plasser(row);
          helkart(0);
          etter(60, function () { kamera(NAER_ZOOM, x, y, DUR_INN); });
          etter(60 + DUR_INN + 80, vis);
          zoomet = true;
          return;
        }

        var dx = x - parseFloat(forrige.dataset.x);
        var dy = y - parseFloat(forrige.dataset.y);
        if (Math.sqrt(dx * dx + dy * dy) <= GLIDE_GRENSE) {
          kamera(NAER_ZOOM, x, y, DUR_GLI);
          flytt(row);
          // Min-en gjør at innholdet aldri byttes etter at vis har startet,
          // om skruene skulle settes så glidet blir kortere enn fadingen.
          etter(Math.min(DUR_FADE, DUR_GLI), function () { fyll(row); });
          etter(DUR_GLI + 80, vis);
        } else {
          helkart(DUR_UT);
          etter(DUR_UT + 40, function () { plasser(row); });
          etter(DUR_UT + 100, function () { kamera(NAER_ZOOM, x, y, DUR_INN); });
          etter(DUR_UT + 100 + DUR_INN + 80, vis);
        }
      }

      // Kameraet regner i piksler; ved resize settes sluttilstanden på nytt.
      // Liveness-guarden gjør at en forlatt instans (DOM swappet under hot
      // reload) aldri rører den nye DOM-en.
      var resizeRaf = 0;
      window.addEventListener('resize', function () {
        if (resizeRaf) return;
        resizeRaf = requestAnimationFrame(function () {
          resizeRaf = 0;
          if (!document.contains(kart)) return;
          if (zoomet && aktiv) kamera(NAER_ZOOM, parseFloat(aktiv.dataset.x), parseFloat(aktiv.dataset.y), 0);
        });
      });

      // Ingen åpningssekvens: kartet står på helkart til brukeren klikker
      // en rad, og første klikk kjører den kinematiske sekvensen.
      var api = { velg: velg, stage: stage };
      API.set(root, api);
      return api;
    }

    // Én delegert lytter for alle registre, bundet til document og dermed
    // immun mot DOM-swaps. Init skjer lazy ved første klikk om nødvendig, og
    // en rot hvis stage er byttet ut under den (morf) init-es på nytt.
    document.addEventListener('click', function (e) {
      var maal = e.target;
      if (!maal || !maal.closest) return;
      var row = maal.closest('[data-skm-v2-regrow]');
      if (!row) return;
      var root = row.closest('[data-skm-v2-register]');
      if (!root) return;
      var api = API.get(root);
      if (api && !root.contains(api.stage)) {
        API.delete(root);
        api = null;
      }
      if (!api) api = initRegister(root);
      if (api) api.velg(row);
    });

    // Eager init setter opp resize-håndteringen før første klikk; klikkene
    // selv går via delegeringen over og trenger den ikke.
    function initAll() {
      document.querySelectorAll('[data-skm-v2-register]').forEach(function (el) {
        initRegister(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-profil-historie"] && !Shopify.designMode) return;
  try {
    
  // Lokatoren på produsentsiden: punkt 6-lokatoren i sluttbildet. Én rolig
  // zoom-inngang når kartet kommer i syne, deretter står sluttbildet.
  // prefers-reduced-motion får sluttbildet direkte uten sekvens, og JS
  // setter endelig tilstand selv (KONSENSUS-arven). Idempotent, re-init ved
  // Theme Editor section-load. Konstantene speiler registerets skruer.
  (function () {
    var NAER_ZOOM = 6.5;   // sluttforstørrelse på prikken, speiler registeret
    var OVERSAMPLE = 5;    // stagen er lagt ut i 500 %, MÅ speile CSS-en
    var DUR_INN = 1200;    // kinematisk innzooming, speiler --t-cinematic
    var AVSLOR = 0.65;     // andel av innzoomingen før oppslaget avsløres

    function redusertBevegelse() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function haversineKm(lat1, lng1, lat2, lng2) {
      var R = 6371;
      var rad = Math.PI / 180;
      var dLat = (lat2 - lat1) * rad;
      var dLng = (lng2 - lng1) * rad;
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * rad) * Math.cos(lat2 * rad) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(a));
    }

    function avstandTekst(km) {
      if (km < 5) return 'under 5 km fra Moelv';
      return 'omtrent ' + (Math.round(km / 5) * 5) + ' km fra Moelv';
    }

    function initLokator(root) {
      if (!root || root.dataset.skmV2PlokInit === '1') return;
      var kart = root.querySelector('[data-plok-kart]');
      var stage = root.querySelector('[data-plok-stage]');
      var oppslag = root.querySelector('[data-plok-oppslag]');
      if (!kart || !stage || !oppslag) return;
      root.dataset.skmV2PlokInit = '1';

      var x = parseFloat(root.dataset.x);
      var y = parseFloat(root.dataset.y);
      var lat = parseFloat(root.dataset.lat);
      var lng = parseFloat(root.dataset.lng);
      var mLat = parseFloat(root.dataset.moelvLat);
      var mLng = parseFloat(root.dataset.moelvLng);
      var zoomet = false;

      if (isFinite(lat) && isFinite(lng) && isFinite(mLat) && isFinite(mLng)) {
        var tekst = avstandTekst(haversineKm(mLat, mLng, lat, lng));
        var avstandEl = root.querySelector('[data-plok-avstand]');
        if (avstandEl) avstandEl.textContent = tekst;
        var srEl = root.querySelector('[data-plok-avstand-tekst]');
        if (srEl) srEl.textContent = ', ' + tekst;
      }

      // Kamera: sentrer prikken i panelet ved visuell skala S. Stagen er
      // oversamplet, så påført skala er S/OVERSAMPLE, mens translatene
      // regnes i panelpiksler og er uavhengige av faktoren.
      function kamera(S, dur) {
        var r = kart.getBoundingClientRect();
        if (!r.width) return;
        var s = S / OVERSAMPLE;
        var tx = r.width / 2 - S * (x / 100) * r.width;
        var ty = r.height / 2 - S * (y / 100) * r.height;
        kart.style.setProperty('--lok-dur', dur + 'ms');
        kart.style.setProperty('--lok-zoom', s);
        stage.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + s + ')';
      }
      function vis() { oppslag.classList.add('er-synlig'); }

      function sluttbilde() {
        if (zoomet) return;
        zoomet = true;
        if (redusertBevegelse()) {
          kamera(NAER_ZOOM, 0);
          vis();
          return;
        }
        kamera(NAER_ZOOM, DUR_INN);
        setTimeout(vis, DUR_INN * AVSLOR);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              sluttbilde();
            }
          });
        }, { threshold: 0.35 });
        io.observe(kart);
      } else {
        sluttbilde();
      }

      // Panelbredden endrer translatene: hold sluttbildet ved resize.
      var raf = 0;
      window.addEventListener('resize', function () {
        if (!zoomet) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { kamera(NAER_ZOOM, 0); });
      });
    }

    function initAlle() {
      document.querySelectorAll('[data-skm-v2-plok]').forEach(function (el) {
        initLokator(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAlle);
    } else {
      initAlle();
    }
    document.addEventListener('shopify:section:load', initAlle);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-talg-familien"] && !Shopify.designMode) return;
  try {
    
/*
  Bilde-fallback for matrisen.

  Liquid kan ikke nil-sjekke et asset. Plassholder-glassene lastes derfor
  optimistisk, og feiler filen, bytter ruta til emblem-vaapenet. Ingen
  brutte bilder, ingen hull i rosteren.

  Lytteren er delegert i capture-fasen fordi error ikke bobler. Guarden gjoer
  den trygg naar Theme Editor laster seksjonen paa nytt.
*/
(function () {
  if (window.__skmTalgFamilienBildefall) return;
  window.__skmTalgFamilienBildefall = true;

  document.addEventListener(
    'error',
    function (e) {
      var img = e.target;
      if (!img || !img.matches || !img.matches('[data-skm-talg-bildefall]')) return;
      var rute = img.closest('[data-skm-talg-rute]');
      if (rute) rute.setAttribute('data-media', 'emblem');
      img.remove();
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-talg-innvendinger"] && !Shopify.designMode) return;
  try {
    
/*
  <details> og <summary> virker uten dette. Skriptet holder bare
  aria-expanded i takt med tilstanden, fordi ikke alle skjermlesere
  eksponerer summary sin utvidingstilstand av seg selv.

  `toggle` bobler ikke, men den passerer capture-fasen fra roten og ned til
  målet. Derfor holder én lytter på document med capture, uten reinit ved
  seksjonslasting i Theme-editoren.
*/
document.addEventListener(
  'toggle',
  function (hendelse) {
    var boks = hendelse.target;
    if (!boks || !boks.classList || !boks.classList.contains('skm-talg-innv__mer')) {
      return;
    }
    var knapp = boks.querySelector('summary');
    if (knapp) {
      knapp.setAttribute('aria-expanded', boks.open ? 'true' : 'false');
    }
  },
  true
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["skm-v2-talg-quiz"] && !Shopify.designMode) return;
  try {
    
/*
  Veiviser-modalen.

  Eier kun modalen og stegene. Kjoepsknappen, varsle-meg og e-postfeltet inne i
  modalen haandteres av `skm-v2-talg-flate.js`, som lytter delegert paa document
  og derfor virker like godt inne i en dialog i top layer.

  ATTRIBUTTNAVNENE ER EGNE (`data-skm-vv-*`). Navnerommet ble valgt fordi
  flate-JS-en da hadde en delegert lytter paa `data-skm-talg-svar` inne i
  `[data-skm-talg-quiz]` fra heroens gamle quiz, og like navn ville kjoert to
  sett logikk paa samme klikk. Den steg-maskinen er fjernet fra flate-JS-en
  2026-08-25, saa kollisjonen finnes ikke lenger. Navnerommet blir staaende
  likevel: det er hva som holder eierskapet tydelig hvis noen tar steg-logikk
  tilbake i den delte fila.

  Det denne fila FAKTISK er avhengig av i `skm-v2-talg-flate.js` er tre
  submit-lyttere: `data-skm-talg-kjop`, `data-skm-talg-varsle` og
  `data-skm-talg-epost`. Forsvinner en av dem, blir kjoepsknappen, varsle-meg
  eller e-postfeltet i modalen stumme uten at noe feiler synlig.

  ALLE LYTTERE ER DELEGERT paa document. Theme Editor bytter seksjons-DOM mange
  ganger i en oekt, og lyttere bundet paa enkeltnoder doer med de gamle nodene.
  Tilstanden bor i en WeakMap paa dialogen.

  ALL SYNLIG TEKST KOMMER FRA LIQUID. Chip-teksten kopieres fra etiketten
  leseren trykket paa. Filen inneholder ingen redaksjonell copy.
*/

(function () {
  if (window.__skmTalgVeiviser) return;
  window.__skmTalgVeiviser = true;

  var TILSTAND = new WeakMap();
  var LUKKETID = 140;

  function redusert() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function liste(verdi) {
    return String(verdi || '')
      .split(',')
      .map(function (x) {
        return x.trim();
      })
      .filter(Boolean);
  }

  /* =========================================================
     Rullelaas
     ========================================================= */

  function laasSide(paa) {
    var rot = document.documentElement;
    if (paa) {
      var bredde = window.innerWidth - rot.clientWidth;
      if (bredde > 0) rot.style.setProperty('--skm-vv-rullefelt', bredde + 'px');
      rot.setAttribute('data-skm-vv-laast', 'ja');
    } else {
      rot.removeAttribute('data-skm-vv-laast');
      rot.style.removeProperty('--skm-vv-rullefelt');
    }
  }

  /* =========================================================
     Tilstand
     ========================================================= */

  function hentTilstand(dlg) {
    var st = TILSTAND.get(dlg);
    if (st && dlg.contains(st.scene)) return st;

    var scene = dlg.querySelector('[data-skm-vv-scene]');
    if (!scene) return null;

    st = {
      dlg: dlg,
      panel: dlg.querySelector('[data-skm-vv-panel]'),
      kropp: dlg.querySelector('[data-skm-vv-kropp]'),
      scene: scene,
      spor: dlg.querySelector('[data-skm-vv-spor]'),
      sti: dlg.querySelector('[data-skm-vv-sti]'),
      steg: {},
      svar: { bruk: null, to: null },
      neste: null,
      utfall: null,
      kandidater: [],
      aktivtDyr: null,
      aktivtSteg: 'bruk',
      apner: null
    };

    scene.querySelectorAll('[data-skm-vv-steg]').forEach(function (el) {
      st.steg[el.getAttribute('data-skm-vv-steg')] = el;
    });

    TILSTAND.set(dlg, st);

    if (window.ResizeObserver) {
      st.ro = new ResizeObserver(function () {
        if (st.scene.getAttribute('data-klar') === 'ja') oppdaterHoyde(st);
      });
      Object.keys(st.steg).forEach(function (k) {
        st.ro.observe(st.steg[k]);
      });
    }

    return st;
  }

  /* =========================================================
     Hoeyden paa scenen
     ========================================================= */

  function oppdaterHoyde(st) {
    // Bare naar scenen faktisk er laast. Er den ikke det, staar stegene i
    // normal flyt og skal beholde sin egen hoeyde.
    if (st.scene.getAttribute('data-klar') !== 'ja') return;
    var aktiv = st.steg[st.aktivtSteg];
    if (!aktiv) return;
    var h = aktiv.getBoundingClientRect().height;
    if (h > 0) st.scene.style.height = h + 'px';
  }

  // Maales foerst naar dialogen er aapen. Noder i en lukket dialog har hoeyde
  // null, saa en maaling ved DOMContentLoaded ville laast scenen til 0.
  //
  // `data-klar` settes KUN naar vi har en ekte maaling. Settes den paa en
  // maaling som er 0, blir alle steg absolutt posisjonert i en scene uten
  // hoeyde, og hele veiviseren blir usynlig. Uten flagget staar stegene i
  // normal flyt med bare det aktive synlig: ingen morfing, men alt virker.
  // Det er den riktige maaten aa feile paa.
  function maalOgLaas(st) {
    st.scene.removeAttribute('data-klar');
    st.scene.style.height = '';
    var aktiv = st.steg[st.aktivtSteg];
    if (!aktiv) return false;
    var h = aktiv.getBoundingClientRect().height;
    if (h <= 0) return false;
    st.scene.style.height = h + 'px';
    st.scene.setAttribute('data-klar', 'ja');
    return true;
  }

  /* =========================================================
     Steg og fremdrift
     ========================================================= */

  // Bakst-stien har ett spoersmaal, de andre to. Fremdriften maa foelge den
  // faktiske stien, ellers lyver den. Derfor ingen «Steg 1 av 2» noe sted.
  function tegnFremdrift(st) {
    if (!st.spor) return;
    var andel;
    if (st.aktivtSteg === 'svar') {
      andel = 1;
    } else if (st.aktivtSteg === 'bruk') {
      andel = 1 / 3;
    } else {
      andel = 2 / 3;
    }
    st.spor.style.setProperty('--andel', String(andel));
  }

  function tegnSti(st) {
    if (!st.sti) return;
    var ledd1 = st.sti.querySelector('[data-skm-vv-stiledd="1"]');
    var ledd2 = st.sti.querySelector('[data-skm-vv-stiledd="2"]');

    var vis1 = st.aktivtSteg !== 'bruk' && !!st.svar.bruk;
    var vis2 = st.aktivtSteg === 'svar' && !!st.svar.to;

    if (ledd1) ledd1.hidden = !vis1;
    if (ledd2) ledd2.hidden = !vis2;
    st.sti.hidden = !vis1;
  }

  function settChip(st, nummer, knapp) {
    if (!st.sti) return;
    var ledd = st.sti.querySelector('[data-skm-vv-stiledd="' + nummer + '"]');
    if (!ledd) return;
    var mal = ledd.querySelector('[data-skm-vv-chiptekst]');
    var kilde = knapp && knapp.querySelector('[data-skm-vv-etikett]');
    if (mal && kilde) mal.textContent = kilde.textContent;
  }

  function visSteg(st, navn, flyttFokus) {
    if (!st.steg[navn]) return;
    st.aktivtSteg = navn;

    Object.keys(st.steg).forEach(function (k) {
      if (k === navn) {
        st.steg[k].setAttribute('data-aktiv', 'ja');
      } else {
        st.steg[k].removeAttribute('data-aktiv');
      }
    });

    tegnFremdrift(st);
    tegnSti(st);

    // Synkront foerst, saa hoeyden er riktig med en gang ogsaa der
    // requestAnimationFrame er strupet. rAF-en etterpaa retter mot endelig
    // layout naar fonter og bilder har satt seg.
    oppdaterHoyde(st);
    if (st.kropp) st.kropp.scrollTop = 0;

    window.requestAnimationFrame(function () {
      oppdaterHoyde(st);
      if (!flyttFokus) return;
      // Fokus paa steggruppa lar skjermleseren lese spoersmaalet som
      // gruppenavn. Det er annonseringen av steget.
      try {
        st.steg[navn].focus({ preventScroll: true });
      } catch (e) {
        st.steg[navn].focus();
      }
    });
  }

  /* =========================================================
     Utfallet
     ========================================================= */

  function finnUtfall(st, nokkel) {
    var treff = null;
    var forste = null;
    st.dlg.querySelectorAll('[data-skm-vv-grunn]').forEach(function (g) {
      if (!forste) forste = g;
      if (treff) return;
      if (liste(g.getAttribute('data-nokler')).indexOf(nokkel) !== -1) treff = g;
    });
    return treff || forste;
  }

  function tegnSvar(st) {
    if (!st.utfall) return;

    st.dlg.querySelectorAll('[data-skm-vv-grunn]').forEach(function (g) {
      g.hidden = g !== st.utfall;
    });

    st.dlg.querySelectorAll('[data-skm-vv-primar]').forEach(function (el) {
      el.hidden = el.getAttribute('data-skm-vv-primar') !== st.aktivtDyr;
    });

    var vist = 0;
    st.dlg.querySelectorAll('[data-skm-vv-bytt]').forEach(function (b) {
      var d = b.getAttribute('data-skm-vv-bytt');
      var skalVises = st.kandidater.indexOf(d) !== -1;
      b.hidden = !skalVises;
      b.setAttribute('aria-pressed', d === st.aktivtDyr ? 'true' : 'false');
      if (skalVises) vist += 1;
    });

    var altrad = st.dlg.querySelector('[data-skm-vv-altrad]');
    if (altrad) altrad.hidden = vist < 2;
  }

  function settUtfall(st) {
    var nokkel = st.neste === 'svar' ? st.svar.bruk : st.svar.bruk + '|' + st.svar.to;
    st.utfall = finnUtfall(st, nokkel);
    if (!st.utfall) return;

    var primar = st.utfall.getAttribute('data-dyr');
    var alt = liste(st.utfall.getAttribute('data-alternativer'));

    st.kandidater = [primar].concat(alt).filter(function (d, i, arr) {
      return d && arr.indexOf(d) === i;
    });
    st.aktivtDyr = primar;

    tegnSvar(st);
  }

  // Tilbake beholder det leseren allerede har svart, saa valget staar merket
  // naar hun kommer tilbake til steget. Start paa nytt toemmer alt.
  function tilbakeTilBruk(st) {
    visSteg(st, 'bruk', true);
  }

  function nullstill(st, flyttFokus) {
    st.svar = { bruk: null, to: null };
    st.neste = null;
    st.utfall = null;
    st.kandidater = [];
    st.aktivtDyr = null;
    st.dlg.querySelectorAll('[data-skm-vv-svar]').forEach(function (b) {
      b.removeAttribute('data-valgt');
    });
    visSteg(st, 'bruk', flyttFokus);
  }

  /* =========================================================
     Aapne og lukke
     ========================================================= */

  function finnDialog(mal) {
    var id = mal && mal.getAttribute('data-skm-talg-apne-quiz');
    if (id) {
      var maal = document.getElementById(id);
      if (maal) return maal;
    }
    return document.querySelector('[data-skm-vv-dialog]');
  }

  function modalMulig() {
    var dlg = document.querySelector('[data-skm-vv-dialog]');
    return !!(dlg && typeof dlg.showModal === 'function');
  }

  // `aria-haspopup` settes herfra og ALDRI i markup. Utloeserne er ankere som
  // peker paa bruksmatrisen, saa uten JS, uten denne seksjonen eller uten
  // showModal finnes det ingen dialog aa varsle om, og attributtet ville vaert
  // en loegn overfor skjermleseren. Denne filen kjoerer bare naar alle tre
  // faktisk er paa plass.
  function merkUtlosere() {
    if (!modalMulig()) return;
    document.querySelectorAll('[data-skm-talg-apne-quiz]').forEach(function (el) {
      el.setAttribute('aria-haspopup', 'dialog');
    });
  }

  function aapne(dlg, apner) {
    if (!dlg || dlg.open) return;
    var st = hentTilstand(dlg);
    if (!st) return;

    st.apner = apner || null;
    dlg.removeAttribute('data-lukker');

    if (typeof dlg.showModal === 'function') {
      dlg.showModal();
    } else {
      // Eldre nettleser uten showModal. Ingen top layer og ingen fokusfelle,
      // saa vi lar utloeseren gjoere jobben sin i stedet: lenka peker paa
      // bruksmatrisen, som gir samme svar.
      return;
    }

    laasSide(true);

    // Maaling maa skje mens dialogen er aapen. Synkront, saa foerste maling er
    // riktig, og en gang til paa neste frame naar animasjonen har satt seg.
    var laast = maalOgLaas(st);
    window.requestAnimationFrame(function () {
      // Kom foerste maaling ut som null, forsoek en gang til naar layout har
      // satt seg. Lykkes den heller ikke da, staar veiviseren i normal flyt.
      if (!laast) maalOgLaas(st);
      oppdaterHoyde(st);
      try {
        st.steg[st.aktivtSteg].focus({ preventScroll: true });
      } catch (e) {
        st.steg[st.aktivtSteg].focus();
      }
    });
  }

  // OPPRYDNINGEN HENGER IKKE PAA `close`-HENDELSEN ALENE.
  //
  // MAALT I NETTLESEREN 2026-08-25: paa QA-temaet fyrte det ingen `close`
  // i det hele tatt, verken paa dialogen selv eller paa document i
  // fangstfasen, og heller ikke for en helt fersk <dialog> laget i samme
  // dokument. `close` var det uendrede innebygde metoden og elementet et ekte
  // HTMLDialogElement, saa aarsaken ligger utenfor denne fila og kan vaere
  // maaleoppsettet. Det spiller ingen rolle for konklusjonen: all opprydning
  // laa i den ene hendelsen, og da den uteble sto siden igjen med
  // `overflow: hidden` og var ikke til aa rulle etter at leseren hadde lukket
  // veiviseren. Fokus kom heller aldri tilbake til knappen hun kom fra.
  //
  // Derfor ryddes det eksplisitt paa hver vei vi selv styrer.
  // `etterLukking` er idempotent, saa fyrer `close` ogsaa, skader det ikke.
  //
  // VEIER SOM IKKE GAAR GJENNOM HIT, rydder heller ikke. Det finnes ingen
  // `<form method="dialog">` i seksjonen i dag, saa dette er ikke en levende
  // feil. Legger noen inn en senere, lukker den dialogen utenom `lukk()`, og
  // da blir rullelaasen staaende uten at noe feiler synlig. Skal du ha en slik
  // form, kall `lukk(dlg)` fra submit i stedet for aa la nettleseren lukke.
  //
  // Rekkefoelgen inni er ogsaa en detalj: `etterLukking` maa staa ETTER
  // `dlg.close()` i begge grener. Staar den foer i den animerte grenen,
  // slippes rullelaasen og fokus returneres mens modalen fortsatt er synlig
  // i LUKKETID millisekunder.
  function lukk(dlg) {
    if (!dlg || !dlg.open) return;
    if (redusert()) {
      dlg.close();
      etterLukking(dlg);
      return;
    }
    if (dlg.getAttribute('data-lukker')) return;
    dlg.setAttribute('data-lukker', 'ja');
    window.setTimeout(function () {
      dlg.removeAttribute('data-lukker');
      if (dlg.open) dlg.close();
      etterLukking(dlg);
    }, LUKKETID);
  }

  function etterLukking(dlg) {
    var st = TILSTAND.get(dlg);
    laasSide(false);
    dlg.removeAttribute('data-lukker');
    if (st && st.apner && st.apner.isConnected) {
      try {
        st.apner.focus({ preventScroll: true });
      } catch (e) {
        st.apner.focus();
      }
    }
  }

  /* =========================================================
     Delegerte lyttere
     ========================================================= */

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;

    var utloser = e.target.closest('[data-skm-talg-apne-quiz]');
    if (utloser) {
      var dlg = finnDialog(utloser);
      if (dlg && typeof dlg.showModal === 'function') {
        // Uten JS eller uten showModal faar lenka staa, saa den hopper til
        // bruksmatrisen. Med modal skal den aldri hoppe.
        e.preventDefault();
        aapne(dlg, utloser);
      }
      return;
    }

    var inne = e.target.closest('[data-skm-vv-dialog]');
    if (!inne) return;
    var st = hentTilstand(inne);
    if (!st) return;

    if (e.target.closest('[data-skm-vv-lukk]')) {
      lukk(inne);
      return;
    }

    var svarknapp = e.target.closest('[data-skm-vv-svar]');
    if (svarknapp) {
      var felt = svarknapp.getAttribute('data-skm-vv-svar');
      var verdi = svarknapp.getAttribute('data-verdi');
      var neste = svarknapp.getAttribute('data-neste');

      var gruppe = svarknapp.parentNode;
      if (gruppe) {
        gruppe.querySelectorAll('[data-skm-vv-svar]').forEach(function (b) {
          b.removeAttribute('data-valgt');
        });
      }
      svarknapp.setAttribute('data-valgt', 'ja');

      if (felt === 'bruk') {
        st.svar.bruk = verdi;
        st.svar.to = null;
        st.neste = neste;
        settChip(st, 1, svarknapp);
      } else {
        st.svar.to = verdi;
        settChip(st, 2, svarknapp);
      }

      if (neste === 'svar') settUtfall(st);
      visSteg(st, neste, true);
      return;
    }

    var chip = e.target.closest('[data-skm-vv-chip]');
    if (chip) {
      var nr = chip.getAttribute('data-skm-vv-chip');
      if (nr === '1') {
        tilbakeTilBruk(st);
      } else if (st.neste && st.steg[st.neste]) {
        visSteg(st, st.neste, true);
      }
      return;
    }

    if (e.target.closest('[data-skm-vv-tilbake]')) {
      // Tilbake fra et andre-spoersmaal gaar alltid til bruksomraadet, som er
      // det eneste steget foran det.
      tilbakeTilBruk(st);
      return;
    }

    if (e.target.closest('[data-skm-vv-omigjen]')) {
      nullstill(st, true);
      return;
    }

    var bytt = e.target.closest('[data-skm-vv-bytt]');
    if (bytt) {
      st.aktivtDyr = bytt.getAttribute('data-skm-vv-bytt');
      tegnSvar(st);
      window.requestAnimationFrame(function () {
        oppdaterHoyde(st);
      });
      return;
    }

    var rull = e.target.closest('[data-skm-vv-rull]');
    if (rull) {
      var maalId = (rull.getAttribute('href') || '').replace('#', '');
      var maalNode = maalId && document.getElementById(maalId);
      if (!maalNode) return;
      e.preventDefault();
      lukk(inne);
      window.setTimeout(
        function () {
          maalNode.scrollIntoView({ behavior: redusert() ? 'auto' : 'smooth', block: 'start' });
          if (maalNode.hasAttribute('tabindex') === false) maalNode.setAttribute('tabindex', '-1');
          try {
            maalNode.focus({ preventScroll: true });
          } catch (err) {
            maalNode.focus();
          }
        },
        redusert() ? 0 : LUKKETID + 20
      );
      return;
    }

    // Klikk paa selve dialogen utenfor panelet lukker. Rektangel-testen taaler
    // klikk paa dialogens egen padding, som `event.target === dialog` ikke gjoer.
    if (e.target === inne && st.panel) {
      var r = st.panel.getBoundingClientRect();
      var utenfor =
        e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom;
      if (utenfor) lukk(inne);
    }
  });

  // `cancel` og `close` BOBLER IKKE. En vanlig lytter paa document ville aldri
  // fyre. Fangstfasen gaar derimot fra document ned til maalet ogsaa for
  // ikke-boblende hendelser, saa `true` er ikke pynt her, den er det som gjoer
  // at Escape og lukking i det hele tatt naar fram.
  document.addEventListener(
    'cancel',
    function (e) {
      var dlg = e.target;
      if (!dlg || !dlg.matches || !dlg.matches('[data-skm-vv-dialog]')) return;
      // Escape lukker, men gjennom vaar egen vei saa animasjonen og
      // opprydningen kjoerer likt uansett hvordan modalen lukkes.
      e.preventDefault();
      lukk(dlg);
    },
    true
  );

  // Escape tas OGSAA paa keydown, ikke bare via `cancel`. Se notatet over
  // `lukk`: `close` uteble helt i maalingen 2026-08-25, og `cancel` er samme
  // slags avhengighet til én innebygd hendelse. Uteblir den, lukker
  // nettleseren dialogen selv uten at noe av vaart kjoerer, og da staar siden
  // igjen laast. Denne veien er vaar egen og gaar gjennom `lukk`, som rydder.
  // preventDefault stopper nettleserens egen lukking, saa det ikke lukkes to
  // ganger, og `lukk` returnerer uansett tidlig paa en dialog som ikke er
  // aapen.
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var dlg = document.querySelector('[data-skm-vv-dialog][open]');
      if (!dlg) return;
      e.preventDefault();
      lukk(dlg);
    },
    true
  );

  // DENNE LYTTEREN FYRER IKKE I CHROME. Den staar likevel, med vilje.
  //
  // Maalt i Chrome 151 paa QA-temaet 2026-08-25, med en syntetisk `close` som
  // kontroll:
  //
  //   syntetisk close (kontroll):   egen=1  cap=1
  //   ekte close() etter 500 ms:    egen=0  cap=0
  //   show() + close():             egen=0  cap=0
  //   form method=dialog:           egen=0  cap=0  (dialogen ER lukket)
  //
  // Kontrollen er det som gjoer maalingen entydig. Den syntetiske hendelsen
  // treffer nettopp disse lytterne 1 av 1, saa lytterne feiler ikke.
  // Nettleseren dispatcher rett og slett ikke hendelsen. Derfor rydder
  // `lukk()` eksplisitt, se notatet der.
  //
  // Firefox og Safari er ikke maalt, og der kan hendelsen godt komme. Lytteren
  // blir derfor staaende som kryssnettleser-nett. `etterLukking` er idempotent,
  // saa fyrer den i tillegg til det eksplisitte kallet, skjer det ingenting.
  //
  // Kommentaren er poenget. Uten den ser dette ut som baerende kode, og det er
  // nettopp fella `flate.js` advarer mot i sin egen topptekst.
  document.addEventListener(
    'close',
    function (e) {
      var dlg = e.target;
      if (!dlg || !dlg.matches || !dlg.matches('[data-skm-vv-dialog]')) return;
      etterLukking(dlg);
    },
    true
  );

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-skm-vv-dialog]').forEach(function (dlg) {
      if (!dlg.open) return;
      var st = TILSTAND.get(dlg);
      if (st && st.scene.getAttribute('data-klar') === 'ja') oppdaterHoyde(st);
    });
  });

  // Theme Editor bytter ut seksjonen. Tilstanden er knyttet til den gamle
  // noden og maa bygges paa nytt, ellers peker den paa doede steg.
  //
  // Bare dialoger som faktisk ble bygget paa nytt nullstilles. Utloeserne bor
  // i ANDRE seksjoner (hero og avslutning), og naar en av dem lastes om mens
  // veiviseren staar aapen, skal verken tilstanden eller rullelaasen roeres.
  // Utloeserne i den nye DOM-en maa derimot merkes paa nytt.
  document.addEventListener('shopify:section:load', function (e) {
    var rot = e.target && e.target.querySelectorAll ? e.target : document;
    rot.querySelectorAll('[data-skm-vv-dialog]').forEach(function (dlg) {
      TILSTAND.delete(dlg);
    });
    if (!document.querySelector('[data-skm-vv-dialog][open]')) laasSide(false);
    merkUtlosere();
  });

  document.addEventListener('shopify:section:select', function (e) {
    var dlg = e.target && e.target.querySelector && e.target.querySelector('[data-skm-vv-dialog]');
    if (dlg) aapne(dlg, null);
  });

  document.addEventListener('shopify:section:deselect', function (e) {
    var dlg = e.target && e.target.querySelector && e.target.querySelector('[data-skm-vv-dialog]');
    if (dlg) lukk(dlg);
  });

  // Begge deler, med vilje. Seksjonspakka lastes normalt utsatt og kjoerer da
  // paa «interactive», der det foerste kallet er nok. Havner filen et sted der
  // dokumentet fortsatt parses, tar lytteren de utloeserne som ikke fantes
  // enda. Merkingen er idempotent, saa dobbeltkjoering koster ingenting, og vi
  // slipper aa vaere avhengige av NAAR temaet velger aa kjoere oss.
  merkUtlosere();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', merkUtlosere);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
